import { ApplicationController, useThrottle } from 'stimulus-use'


export default class extends ApplicationController {
  static throttles = ['submit']

  connect() {
    this.disabled = false
    useThrottle(this, { wait: 200 })
  }


  enableForm() {
    this.disabled = false
  }

  submitForm() {
    if (this.disabled) return
    this.disabled = true
    this.element.requestSubmit()
  }

  suppressEnter(e) {
    e.preventDefault()
  }

  handleEnter(e) {
    e.preventDefault()
    this.submitForm()
  }

  handleKeyup(e) {
    if (e.key === 'Enter') {
      this.handleEnter(e)
    }
  }
}